import React from "react";
import { useSelector } from "react-redux/es/hooks/useSelector";

// import AnimatedPageContainer from "../../assets/containers/AnimatedPageContainer";
import UserAvatar from "./UserAvatar";
import DashboardSearchInput from "../../assets/components/DashboardSearchInput";
import DashboardMenu from "./DashboardMenu";
import SocialSec from "./SocialSec";
import { useNavigate } from "react-router-dom";

const Dashboard = () => {
  const { currentUser } = useSelector(({ user }) => user);
  const navigate = useNavigate();

  return (
    <div className="customContainer">
      <UserAvatar
        userAvatar={currentUser?.profileImage}
        userName={currentUser?.fullName}
        handleClick={() => navigate("/profile")}
      />
      <DashboardSearchInput />
      <DashboardMenu />
      <SocialSec />
    </div>
  );
};

export default Dashboard;
